<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <!-- 主内容 -->
    <div class="container-s">
      <div class="content">
        <div class="ptit">
          <div class="title">合作伙伴</div>
          <p>{{partnerInfo}}</p>
        </div>
        <div class="coop_pars">
          <div class="blockbox">
           <ul>
              <li v-for="(item,index) in list">
                <a :href="item.url" target="_blank">
                  <span class="log"><img :src="base_url + item.imgUrl"></span>
                  <p class="des taj">
                    {{item.name}}<br>
                    {{item.content}}
                  </p>
                </a>
              </li>
            </ul>
            <!-- <div class="page">
              <span class="current">1</span>
              <a class="num" href="javascript:;">2</a>
              <a class="num" href="javascript:;">3</a>
              <a class="next" href="javascript:;">&gt;</a>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
  import axios from 'axios';
  var CONFIG = require('../../common/config.js');
  var base_url = CONFIG.API_URL.BASE_URL;

  var pageIndex = 1;
  var pageSize = 10;
  var allPages = 0;
  var bStop = true;
  var is_click = true;

  //页面初始化数据
  var pagingPartner = function(that) {
    axios.post(base_url+'front/pagingPartner', {page:pageIndex,limit:pageSize}).then(function (res) {
      bStop = true;
      var data = res.data.result;
      //console.log(data);
      var list = that.list;
      //成功查询到结果集
      if (res.data.code == 0) { //查询成功
        for (var i = 0; i < data.records.length; i++) {
          list.push(data.records[i]);
        }
        allPages = data.records.total;
      }
      that.list = list;
      pageIndex++;
    });
  }

  export default {
    data () {
      return {
        base_url:base_url,
        partnerInfo:'',
        list:[]
      }
    },

    created: function () {
    	var that = this;
      pageIndex = 1;
      that.list = [];
      pagingPartner(that);
      //获取合作伙伴
      that.getConfigInfo();
  },
    methods: {

      //获取合作伙伴
      getConfigInfo:function(){
        var that = this;
        axios.post(base_url+'front/getConfigInfo', {'item_key':'partner'}).then(function (res) {
          var data = res.data.result;
          that.partnerInfo = data;
        });
      },
    }
  }
</script>

<style>
  @import url("./partner.css");
</style>



// WEBPACK FOOTER //
// src/views/partner/partner.vue